// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.method-container {
  border-bottom: 1px solid #cccccc;
  padding: 10px;
  margin-bottom: 10px;
}

.btn.btn-link {
  padding: 0;
  min-height: auto;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImJhc2UuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxnQ0FBQTtFQUNBLGFBQUE7RUFDQSxtQkFBQTtBQUNGOztBQUVBO0VBQ0ksVUFBQTtFQUNBLGdCQUFBO0FBQ0oiLCJmaWxlIjoiYmFzZS5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5tZXRob2QtY29udGFpbmVyIHtcbiAgYm9yZGVyLWJvdHRvbTogMXB4IHNvbGlkICNjY2NjY2M7XG4gIHBhZGRpbmc6IDEwcHg7XG4gIG1hcmdpbi1ib3R0b206IDEwcHg7XG59XG5cbi5idG4uYnRuLWxpbmsge1xuICAgIHBhZGRpbmc6IDA7XG4gICAgbWluLWhlaWdodDogYXV0bztcbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/shared/enrollment/methods/base/base.component.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACI,UAAA;EACA,gBAAA;AACJ;AACA,whBAAwhB","sourcesContent":[".method-container {\n  border-bottom: 1px solid #cccccc;\n  padding: 10px;\n  margin-bottom: 10px;\n}\n\n.btn.btn-link {\n    padding: 0;\n    min-height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
